import { render, staticRenderFns } from "./GlobalFilterSummary.vue?vue&type=template&id=56532ffd&scoped=true&"
import script from "./GlobalFilterSummary.vue?vue&type=script&lang=js&"
export * from "./GlobalFilterSummary.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFilterSummary.vue?vue&type=style&index=0&id=56532ffd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56532ffd",
  null
  
)

export default component.exports